import { initAnimations } from "../components/animations";
import { initToast } from "../components/modal";

initAnimations();
initToast();



const $slider = document.getElementById('slider');
const $slides = document.querySelectorAll('.slider__item');
const $btnNext = document.getElementById('next');
const $btnPrev = document.getElementById('prev');
let activeSlideIndex: number = 0;

$btnNext?.addEventListener('click', () => {
  $slides[activeSlideIndex].classList.remove('slider__item--active');
  $slides[activeSlideIndex].classList.remove('slider__item--tada');

  activeSlideIndex = (activeSlideIndex + 1) % $slides.length;

  $slides[activeSlideIndex].classList.add('slider__item--active');
  $slides[activeSlideIndex].classList.add('slider__item--tada');
});

$btnPrev?.addEventListener('click', () => {
  $slides[activeSlideIndex].classList.remove('slider__item--active');
  $slides[activeSlideIndex].classList.remove('slider__item--tada');

  activeSlideIndex--;
  if (activeSlideIndex < 0) {
    activeSlideIndex = $slides.length - 1;
  }
  $slides[activeSlideIndex].classList.add('slider__item--active');
  $slides[activeSlideIndex].classList.add('slider__item--tada');
});


$btnNext?.addEventListener('mouseenter', () => {

  if (window.matchMedia('(hover: hover)').matches) {
    $slider?.style.setProperty('--sat', '1');
    $slider?.style.setProperty('--br', '1');
  }
});

$btnNext?.addEventListener('mouseleave', () => {
  if (window.matchMedia('(hover: hover)').matches) {
    $slider?.style.setProperty('--sat', '0');
    $slider?.style.setProperty('--br', '0.7');
  }
});



const setScrollbarWidth = () => {
  const width = window.innerWidth - document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--scrollbar-width', `${width}px`);
};
const $btnBurger = document.getElementById('btn-burger');
const $wrapperBtnBurger = document.getElementById('wrapper-burger');
const $asideMenu = document.getElementById('aside-menu');
let menuOpen = false;


const toggleMenu = () => {
  $btnBurger?.classList.toggle('burger-btn--active', menuOpen);
  $asideMenu?.classList.toggle('header__aside--active', menuOpen);
  document.body.classList.toggle('is-lock', menuOpen);
}
window.addEventListener('click', (e) => {
  if(!menuOpen && !$wrapperBtnBurger?.contains(e.target as HTMLElement)) return;

  setScrollbarWidth();
  if ($wrapperBtnBurger?.contains(e.target as HTMLElement)) {
    menuOpen = !menuOpen
    toggleMenu();

  } else if (menuOpen && !$asideMenu?.contains(e.target as HTMLElement)) {
    menuOpen = false;
    toggleMenu();
  }
})




const $video = document.getElementById('video') as HTMLVideoElement;
const $wrapperVideo = document.getElementById('video-container');
let viewHeight = document.documentElement.clientHeight;
let documentHeight = getDocumentHeight();
let maxScroll = documentHeight - viewHeight;
let ticking = false;
let isPaused = false;
const updateMetrics = () => {
  viewHeight = document.documentElement.clientHeight;
  documentHeight = getDocumentHeight()
  maxScroll = documentHeight - viewHeight;  
};
const debouncedResize = debounce(updateMetrics, 250);

window.addEventListener('resize', debouncedResize);
window.addEventListener('scroll', () => {
  const scrollY = window.scrollY;
  if (scrollY > 200 && $wrapperVideo && !isPaused) {
   $video.pause();
   isPaused = true;
  } else if (scrollY <= 300 && isPaused) {
    $video.play();
    isPaused = false;
  }

  if (!ticking) {
    window.requestAnimationFrame(() => {
      if ($wrapperVideo) {
        $wrapperVideo.style.opacity = `${1 - (window.scrollY / maxScroll * 1.3)}`;
      }
      ticking = false;
    });

    ticking = true;
  }
});

function getDocumentHeight() {
  
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );
}
function debounce(fn: Function, ms: number) {
  let timeoutId: ReturnType<typeof setTimeout>;
  return function(this: any, ...args: any[]) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
}